import Marks from './Marks';

// this function checks if the cursor is inbetween the word
const isInbetween = (editor) => {
  let check = false;
  const { selection: initialSelection } = editor.value;
  editor.moveAnchorBackward(1);
  editor.moveFocusForward(1);
  if (
    editor.value.fragment.text.length === 2 &&
    Marks[editor.value.fragment.text.charAt(0)] !== true &&
    Marks[editor.value.fragment.text.charAt(1)] !== true
  ) {
    check = true;
  }
  editor.select(initialSelection);
  return check;
};

export default isInbetween;
